import Axios from '../Helpers/axios';
import Swal from 'sweetalert2';

export const get_datalistbox = async (placeholder, Controller, Metodo, variables) => {
    try
    {
        const respuesta = await Axios({
            url : `${Controller}/${Metodo}`,
            method : 'GET',
            params : {...variables}
        })

        const {data} = respuesta;

        return data;
    }
    catch(e)
    {
        Swal.fire('Oops!', `Ha ocurrido un problema al cargar el listbox [${placeholder}], por favor actualiza la pagina.`, 'error');
        return false;
    }
}

export const deleteFile = async (Controller, Metodo, variables) => {
    try
    {
        const respuesta = await Axios({
            url : `${Controller}/${Metodo}`,
            method : 'PUT',
            data : {...variables}
        })

        const { data } = respuesta;

        return data;
    }
    catch (error)
    {
        Swal.fire('Oops!', `Ha ocurrido un problema al eliminar el archivo, por favor actualiza la pagina.`, 'error');
        return false;
    }
}

export const verificaImgPerfil = async () => {
    try
    {
        const respuesta = await Axios({
            url : 'General/verificaImgPerfil',
            method : 'GET'
        })

        const {data} = respuesta;

        return data;
    }
    catch (error)
    {
        Swal.fire('Oops!', `Ha ocurrido un problema al obtener la imagen de perfil, por favor actualiza la pagina.`, 'error');
        return false;
    }
}

export const downloadFile = async (URL_ARCHIVO) => {
    try
    {
        const respuesta = await Axios({
            url : 'General/downloadFile',
            method : 'GET',
            params : {URL_ARCHIVO : URL_ARCHIVO},
            responseType : 'blob'
        })

        return respuesta;
    }
    catch (e)
    {
        Swal.fire('Oops!', 'Ha ocurrido un problema al descargar el archivo, por favor intentalo otra vez.', 'error')
        return false;
    }
}

export const comprimirDescargarDirectorio = async (data_zip_download) => {
    try
    {
        const respuesta =  await Axios({
            url : 'General/comprimirDescargarDirectorio',
            method : 'GET',
            responseType : 'blob',
            params : {...data_zip_download}
        })

        return respuesta;

    }
    catch (e)
    {
        Swal.fire('Oops!', 'Ha ocurrido un problema al descargar el archivo, por favor intentalo otra vez.', 'error')
        return false;
    }
}

export const getDataUsuarioUserCard = async (idUsuario, setStateDataUser) => {
    try
    {
        await Axios({
            url : 'General/getDataUsuarioUserCard',
            method : 'GET',
            params : {IDUSUARIO : idUsuario}
        })
        .then(data_return => setStateDataUser({loading : false, data : {...data_return.data.data}}))
    }
    catch (error)
    {
        Swal.fire('Oops!', 'Ha ocurrido un problema al obtener la informacion del usuario, por favor intentalo otra vez.', 'error')
        return false;
    }
}